/**
* 公司数据仓库
*/
const companyRepository = {
  
setCompanyRepository: "/api/setCompanyRepository",//设置公司数据仓库
getCompanyRepository: "/api/getCompanyRepository",//查询公司数据仓库
}

export default companyRepository